module.exports = __webpack_public_path__ + "media/images/pastel-pink-0d65d3669d186dec92c1e9102c23e0aa.png";